import ReactDOM from "react-dom/client";
import "./i18n";
import "./index.min.css";
import "./tailwind.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import Loader from "./components/loader";

const root = ReactDOM.createRoot(document.getElementById("root"));
const App = lazy(() => import("./App"));

const renderLoader = () => <Loader />;

// ✅ SERVICE WORKER (version clean)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");
      console.log("✅ SW enregistré :", reg);
    } catch (err) {
      console.error("❌ SW erreur :", err);
    }
  });
}

root.render(
  <BrowserRouter>
    <Suspense fallback={renderLoader()}>
      <App />
    </Suspense>
  </BrowserRouter>
);

reportWebVitals();